import React from 'react';

const ACCESS_TOKEN = 'pk.eyJ1Ijoicm91dGU0dSIsImEiOiJjaW5rYXV1bmgwMDZtdnZseTh0Z2l5azFnIn0.SjjQEIHK2qF7JR5BN3xgWg';
const ZOOM = 17;

export default function StaticMap({coords}) {
	return (
		<div>
			{coords ? (
				<img
					alt="map"
					style={{maxWidth: '100%'}}
					src={`https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/${coords.longitude},${coords.latitude},${ZOOM}/600x600?access_token=${ACCESS_TOKEN}`}
				/>
			) : (
				<div>Helyadatok betöltése</div>
			)}
		</div>
	);
}
